import { render } from "./BaseSummaryList.vue?vue&type=template&id=78cce93b"
import script from "./BaseSummaryList.vue?vue&type=script&lang=js"
export * from "./BaseSummaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__